import apiClient from './apiClient';
import { config } from '../../services/config.js';

export const reverseGeocode = (lat, lon) => apiClient.get(`${config.location.nominatimUrl}/reverse?format=json&lat=${lat}&lon=${lon}`, { skipAuth: true });
export const searchLocation = (query) => apiClient.get(`${config.location.nominatimUrl}/search?q=${encodeURIComponent(query)}, Nepal&format=json&limit=10&countrycodes=np`, { skipAuth: true });
